export default {
  hhp: [
    {
      name: 'Holdings',
      disabled: true,
      sortBy: 'noH',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Entreprises',
      disabled: false,
      sortBy: 'eC',
      thCss: 'td td_number pTop16',
      i: true
    },
    {
      name: 'Contrats',
      disabled: false,
      sortBy: 'cC',
      thCss: 'td td_number pTop16',
      i: true
    },
    {
      name: 'Assurés/ayants<br>droit',
      disabled: false,
      sortBy: 'aC',
      thCss: 'td td_number pTop8',
      i: true
    },
    {
      name: 'Cotisations<br>encaissées',
      disabled: false,
      sortBy: 'cs',
      thCss: 'td td_cotpre pTop8',
      i: true
    },
    {
      name: 'Prestations<br>survenues',
      disabled: false,
      sortBy: 'ps',
      thCss: 'td td_cotpre pTop8',
      i: true
    },
    {
      name: 'Taux de télétransmission',
      disabled: false,
      sortBy: 'tCs',
      thCss: 'td td_progress pTop16',
      i: true
    },
    {
      name: 'Documents',
      disabled: false,
      sortBy: 'eC',
      thCss: 'td td_doc pTop16',
      i: false
    },
  ],
  ehp: [
    {
      name: 'Entreprises',
      disabled: true,
      sortBy: 'noC',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Contrats',
      disabled: false,
      sortBy: 'cC',
      thCss: 'td td_number pTop16',
      i: true
    },
    {
      name: 'Assurés/ayants<br>droit',
      disabled: false,
      sortBy: 'aC',
      thCss: 'td td_number pTop8',
      i: true
    },
    {
      name: 'Cotisations<br>encaissées',
      disabled: false,
      sortBy: 'cs',
      thCss: 'td td_cotpre pTop8',
      i: true
    },
    {
      name: 'Prestations<br>survenues',
      disabled: false,
      sortBy: 'ps',
      thCss: 'td td_cotpre pTop8',
      i: true
    },
    {
      name: 'Taux de télétransmission',
      disabled: false,
      sortBy: 'tCs',
      thCss: 'td td_progress pTop16',
      i: true
    },
    {
      name: 'Documents',
      disabled: false,
      sortBy: 'eC',
      thCss: 'td td_doc pTop16',
      i: false
    },
  ],
  chp: [
    {
      name: 'Entreprises',
      disabled: true,
      sortBy: 'noC',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Contrats',
      disabled: true,
      sortBy: '_lb',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Assurés/ayants<br>droit',
      disabled: false,
      sortBy: 'iA',
      thCss: 'td td_number pTop8',
      i: true
    },
    {
      name: 'Types',
      disabled: false,
      sortBy: '_t',
      thCss: 'td td_number pTop16',
      i: true
    },
    {
      name: 'Catégories',
      disabled: false,
      sortBy: '_a',
      thCss: 'td td_categorie pTop16',
      i: true
    },
    {
      name: 'Collèges',
      disabled: false,
      sortBy: '_o',
      thCss: 'td td_college pTop16',
      i: true
    },
    {
      name: 'Assureurs',
      disabled: false,
      sortBy: '_s',
      thCss: 'td td_assureur pTop16',
      i: true
    },
    {
      name: 'Reseaux<br>de soin',
      disabled: false,
      sortBy: '_r',
      thCss: 'td td_number pTop8',
      i: true
    },
    {
      name: 'Cotisations<br>encaissées',
      disabled: false,
      sortBy: 'cs',
      thCss: 'td td_cotpre pTop8',
      i: true
    },
    {
      name: 'Prestations<br>survenues',
      disabled: false,
      sortBy: 'ps',
      thCss: 'td td_cotpre pTop8',
      i: true
    }
  ],
  cotiCol: [
    {
      name: 'Entreprises',
      disabled: true,
      sortBy: 'noC',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Contrats',
      disabled: true,
      sortBy: '_l',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Types',
      disabled: false,
      sortBy: '_tc',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Catégories',
      disabled: false,
      sortBy: '_cg',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Collèges',
      disabled: false,
      sortBy: '_cl',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Montants<br>encaissés',
      disabled: false,
      sortBy: 'me',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Dates de<br>l\'encaissement',
      disabled: false,
      sortBy: 'de_',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Statuts<br>cotisation',
      disabled: false,
      sortBy: '_s',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'DSN',
      disabled: false,
      sortBy: '_d',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Modes de<br>règlement',
      disabled: false,
      sortBy: '_td',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Début de<br>période',
      disabled: false,
      sortBy: 'dp_',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Fin de<br>période',
      disabled: false,
      sortBy: 'fp_',
      thCss: 'td td_date pTop8',
      i: true
    }
  ],
  cotiInd: [
    {
      name: 'Entreprises',
      disabled: true,
      sortBy: 'noC',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Contrats',
      disabled: true,
      sortBy: '_l',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Types',
      disabled: false,
      sortBy: '_tc',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Catégories',
      disabled: false,
      sortBy: '_cg',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Collèges',
      disabled: false,
      sortBy: '_cl',
      thCss: 'td td_date pTop16',
      i: true
    },
    {
      name: 'Montants<br>appelés',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Montants<br>encaissés',
      disabled: false,
      sortBy: 'me',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Début de<br>période',
      disabled: false,
      sortBy: 'dp_',
      thCss: 'td td_date pTop8',
      i: true
    },
    {
      name: 'Fin de<br>période',
      disabled: false,
      sortBy: 'fp_',
      thCss: 'td td_date pTop8',
      i: true
    }
  ],
  prestaHolding: [
    {
      name: 'Entreprises',
      disabled: true,
      sortBy: 'noC',
      thCss: 'td td_name pTop16',
      i: true
    },
    {
      name: 'Frais réels',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop16',
      i: true
    },
    {
      name: 'Remboursement<br>RO',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop8',
      i: true
    },
    {
      name: 'Remboursement<br>autre mutuelle',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop8',
      i: true
    },
    {
      name: 'Remboursement<br>CPMS Base',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop8',
      i: true
    },
    {
      name: 'Remboursement<br>CPMS Opt/Surc',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop8',
      i: true
    },
    {
      name: 'Remboursement<br>CPMS TOTAL',
      disabled: false,
      sortBy: 'ma',
      thCss: 'td td_pre_hol pTop8',
      i: true
    },
  ]
}
